<div class="container-fluid glb-popup">

  @if (formLoading || sendingCreditAuth || processingRefund || loadingCardInfo) {
    <div class="loading-overlay">
      <p-progressSpinner strokeWidth="4" animationDuration=".6s"></p-progressSpinner>
    </div>
  }

  <h2> {{formTitle}}</h2>
  <p-toast [style]="{marginTop: '80px'}">
  </p-toast>
  <p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

  <button mat-icon-button [mat-dialog-close]="true" style="float:right;top:-50px;background-color: transparent;">
    <mat-icon>close</mat-icon>
  </button>
  <hr>
  <p-tabView [(activeIndex)]="activeTabIndex">
    <p-tabPanel header="Details">
    <div [formGroup]="form1" class="forms w-100 d-block">
      <div class="row">
        <div class="col-lg-12">
          @if (formAlert) {
            <div class="w-100 mb-3">
              <div class="w-100"
                style="text-align: center; background-color: yellow;padding:5px;margin-bottom:15px;">
                <p><b>{{formAlert}}</b></p>
              </div>
            </div>
          }
        </div>

      <div class="col-lg-2">
        <span class="p-float-label w-100 mb-3">
          <p-dropdown dropdownIcon="fa fa-caret-down" class="w-100" [options]="statuses" formControlName="status" optionLabel="name"
          optionValue="value" placeholder="Status"></p-dropdown>
          <label for="Status">Status</label>
          @for (validation of validationMessages.status; track validation) {
            <span>
              @if (form1.get('status').hasError(validation.type) && (form1.get('status').dirty || form1.get('status').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>
      <div class="col-lg-4">
        <app-reservation-select [placeholder]="'Enter reservation id and select'" (reservationInfoEvent)="reservationInfoItem($event)" [title]="title"
        [reservationId]="reservationId"> </app-reservation-select>
        <span>
          @if (isReservationId) {
            <small class="p-invalid">Reservation is required
            </small>
          }
        </span>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-2">
        <span class="p-float-label required-field w-100 mb-3">
          <p-dropdown dropdownIcon="fa fa-caret-down" [options]="properties" formControlName="shortTermRentalId"
            optionLabel="propertyCode" optionValue="shortTermRentalId" [filter]="true" filterBy="propertyCode"
            [showClear]="false" placeholder="Property">
          </p-dropdown>
          <label for="Select Property">Select Property</label>
          @for (validation of validationMessages.shortTermRentalId; track validation) {
            <span>
              @if (form1.get('shortTermRentalId').hasError(validation.type) && (form1.get('shortTermRentalId').dirty || form1.get('shortTermRentalId').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>
      <div class="col-lg-2">
        <span class="p-float-label required-field w-100 mb-3">
          <input formControlName="orderId" id="orderId" type="text" readonly pInputText>
          <label for="orderId">Order Id</label>
          @for (validation of validationMessages.orderId; track validation) {
            <span>
              @if (form1.get('orderId').hasError(validation.type) && (form1.get('orderId').dirty || form1.get('orderId').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-2">
        <span class="p-float-label w-100 mb-3">
          <p-calendar appendTo="body" formControlName="checkInDate" inputId="checkInDate" appendTo="body">
          </p-calendar>
          <label for="checkInDate">CheckIn Date</label>
          @for (validation of validationMessages.checkInDate; track validation) {
            <span>
              @if (form1.get('checkInDate').hasError(validation.type) && (form1.get('checkInDate').dirty || form1.get('checkInDate').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>
    </div>

    <div class="row">
      <div class="col-lg-2">
        <span class="p-float-label w-100 mb-3">
          <p-calendar appendTo="body" formControlName="checkOutDate" inputId="checkOutDate" appendTo="body">
          </p-calendar>
          <label for="checkOutDate">CheckOut Date</label>
          @for (validation of validationMessages.checkOutDate; track validation) {
            <span>
              @if (form1.get('checkOutDate').hasError(validation.type) && (form1.get('checkOutDate').dirty || form1.get('checkOutDate').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>
      <div class="col-lg-2">
        <span class="p-float-label w-100 mb-3">
          <p-calendar appendTo="body" formControlName="actualCheckInDate" inputId="actualCheckInDate" appendTo="body">
          </p-calendar>
          <label for="actualCheckInDate">Actual CheckIn Date</label>
          @for (validation of validationMessages.actualCheckInDate; track validation) {
            <span>
              @if (form1.get('actualCheckInDate').hasError(validation.type) && (form1.get('actualCheckInDate').dirty || form1.get('actualCheckInDate').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>

      <div class="col-lg-2">
        <span class="p-float-label w-100 mb-3">
          <p-calendar appendTo="body" formControlName="actualCheckOutDate" inputId="actualCheckOutDate" appendTo="body">
          </p-calendar>
          <label for="actualCheckOutDate">Actual CheckOut Date</label>
          @for (validation of validationMessages.actualCheckOutDate; track validation) {
            <span>
              @if (form1.get('actualCheckOutDate').hasError(validation.type) && (form1.get('actualCheckOutDate').dirty || form1.get('actualCheckOutDate').touched)) {
                <small class="p-invalid"
                  >{{validation.message}}
                </small>
              }
            </span>
          }
        </span>
      </div>
    </div>

    <div class="row mt-2 mb-1">
      <div class="col-lg-6">
        <span class="p-float-label required-field w-100 mb-3">
          <textarea formControlName="issueDesc" id="issueDesc" [rows]="2" pInputTextarea class="w-100"></textarea>
          <label for="issueDesc">Overall Issue Description</label>
          @for (validation of validationMessages.issueDesc; track validation) {
            <span>
              @if (form1.get('issueDesc').hasError(validation.type) && (form1.get('issueDesc').dirty || form1.get('issueDesc').touched)) {
                <small class="p-invalid">{{validation.message}}</small>
              }
            </span>
          }
        </span>
      </div>
    </div>

    @if (guestRefundId) {
      <div class="mb-2 mt-1">
        <div class="fw-bold fs-6 title">Refund Status</div>
      </div>
      <div class="row">
        <div class="col-lg-2">
          <span class="p-float-label w-100 mb-3">
            <p-calendar appendTo="body" formControlName="submittedDate" inputId="submittedDate" appendTo="body">
            </p-calendar>
            <label for="submittedDate">Submitted Date</label>
            @for (validation of validationMessages.submittedDate; track validation) {
              <span>
                @if (form1.get('submittedDate').hasError(validation.type) && (form1.get('submittedDate').dirty || form1.get('submittedDate').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-2">
          <span class="p-float-label w-100 mb-3">
            <p-calendar appendTo="body" formControlName="creditAuthSendDate" inputId="creditAuthSendDate"
              appendTo="body">
            </p-calendar>
            <label for="creditAuthSendDate">Credit Auth Send Date</label>
            @for (validation of validationMessages.creditAuthSendDate; track validation) {
              <span>
                @if (form1.get('creditAuthSendDate').hasError(validation.type) && (form1.get('creditAuthSendDate').dirty || form1.get('creditAuthSendDate').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-2">
          <span class="p-float-label w-100 mb-3">
            <p-calendar appendTo="body" formControlName="creditAuthRcvDate" inputId="creditAuthRcvDate" appendTo="body">
            </p-calendar>
            <label for="creditAuthRcvDate">Credit Auth Rcv Date</label>
            @for (validation of validationMessages.creditAuthRcvDate; track validation) {
              <span>
                @if (form1.get('creditAuthRcvDate').hasError(validation.type) && (form1.get('creditAuthRcvDate').dirty || form1.get('creditAuthRcvDate').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-2">
          <span class="p-float-label w-100 mb-3">
            <p-calendar appendTo="body" formControlName="acctRcvDate" inputId="acctRcvDate" appendTo="body">
            </p-calendar>
            <label for="acctRcvDate">Acct Rcv Date</label>
            @for (validation of validationMessages.acctRcvDate; track validation) {
              <span>
                @if (form1.get('acctRcvDate').hasError(validation.type) && (form1.get('acctRcvDate').dirty || form1.get('acctRcvDate').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-2">
          <span class="p-float-label w-100 mb-3">
            <p-calendar appendTo="body" formControlName="acctProcessDate" inputId="acctProcessDate" appendTo="body">
            </p-calendar>
            <label for="acctProcessDate">Acct Process Date</label>
            @for (validation of validationMessages.acctProcessDate; track validation) {
              <span>
                @if (form1.get('acctProcessDate').hasError(validation.type) && (form1.get('acctProcessDate').dirty || form1.get('acctProcessDate').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-2">
          <span class="p-float-label w-100 mb-3">
            <p-calendar appendTo="body" formControlName="guestRcvFundsEstDate" inputId="guestRcvFundsEstDate"
              appendTo="body">
            </p-calendar>
            <label for="guestRcvFundsEstDate">Guest Rcv Funds Est Date</label>
            @for (validation of validationMessages.guestRcvFundsEstDate; track validation) {
              <span>
                @if (form1.get('guestRcvFundsEstDate').hasError(validation.type) && (form1.get('guestRcvFundsEstDate').dirty || form1.get('guestRcvFundsEstDate').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
      </div>

    }

    <div class="mt-2">
      <div class="mb-2">
        <div class="fw-bold fs-6 title">Guest Contact</div>
      </div>
      <div class="row">
        <div class="col-lg-3">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="firstName" id="firstName" type="text" pInputText>
            <label for="firstName">First Name</label>
            @for (validation of validationMessages.firstName; track validation) {
              <span>
                @if (form1.get('firstName').hasError(validation.type) && (form1.get('firstName').dirty || form1.get('firstName').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-3">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="lastName" id="lastName" type="text" pInputText>
            <label for="lastName">Last Name</label>
            @for (validation of validationMessages.lastName; track validation) {
              <span>
                @if (form1.get('lastName').hasError(validation.type) && (form1.get('lastName').dirty || form1.get('lastName').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-3">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="mobilePhone" id="mobilePhone" type="text" pInputText>
            <label for="mobilePhone">Mobile Phone</label>
            @for (validation of validationMessages.mobilePhone; track validation) {
              <span>
                @if (form1.get('mobilePhone').hasError(validation.type) && (form1.get('mobilePhone').dirty || form1.get('mobilePhone').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-3">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="emailAddress" id="emailAddress" type="text" pInputText>
            <label for="lastName">Email Address</label>
            @for (validation of validationMessages.emailAddress; track validation) {
              <span>
                @if (form1.get('emailAddress').hasError(validation.type) && (form1.get('emailAddress').dirty || form1.get('emailAddress').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-3">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="adr1" id="adr1" type="text" pInputText>
            <label for="adr1">Address1</label>
            @for (validation of validationMessages.adr1; track validation) {
              <span>
                @if (form1.get('adr1').hasError(validation.type) && (form1.get('adr1').dirty || form1.get('adr1').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-3">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="adr2" id="adr2" type="text" pInputText>
            <label for="adr2">Address2</label>
            @for (validation of validationMessages.adr2; track validation) {
              <span>
                @if (form1.get('adr2').hasError(validation.type) && (form1.get('adr2').dirty || form1.get('adr2').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-2">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="adrCity" id="adrCity" type="text" pInputText>
            <label for="adrCity">City</label>
            @for (validation of validationMessages.adrCity; track validation) {
              <span>
                @if (form1.get('adrCity').hasError(validation.type) && (form1.get('adrCity').dirty || form1.get('adrCity').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-2">
          <span class="p-float-label required-field w-100 mb-3">
            <p-dropdown dropdownIcon="fa fa-caret-down" [options]="states" formControlName="adrState" optionLabel="name"
              appendTo="body" optionValue="abbr" [filter]="true" filterBy="name" [showClear]="false"
              placeholder="Select State">
            </p-dropdown>
            <label for="Select State">Select State</label>
            @for (validation of validationMessages.adrState; track validation) {
              <span>
                @if (form1.get('adrState').hasError(validation.type) && (form1.get('adrState').dirty || form1.get('adrState').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>

        <div class="col-lg-2">
          <span class="p-float-label required-field w-100 mb-3">
            <input formControlName="adrPostalCode" id="adrPostalCode" type="text" pInputText>
            <label for="adrPostalCode">Postal Code</label>
            @for (validation of validationMessages.adrPostalCode; track validation) {
              <span>
                @if (form1.get('adrPostalCode').hasError(validation.type) && (form1.get('adrPostalCode').dirty || form1.get('adrPostalCode').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
      </div>

      <div class="row">
        <div class="col-lg-2">
          <span class="p-float-label required-field w-100 mb-3">
            <p-dropdown dropdownIcon="fa fa-caret-down" [options]="countries" formControlName="adrCountry"
              optionLabel="name" appendTo="body" optionValue="abbr" [filter]="true" filterBy="name" [showClear]="false"
              placeholder="Select Country">
            </p-dropdown>
            <label for="Select Country">Select Country</label>
            @for (validation of validationMessages.adrCountry; track validation) {
              <span>
                @if (form1.get('adrCountry').hasError(validation.type) && (form1.get('adrCountry').dirty || form1.get('adrCountry').touched)) {
                  <small class="p-invalid"
                    >{{validation.message}}
                  </small>
                }
              </span>
            }
          </span>
        </div>
      </div>
    </div>

    @if (guestRefundId) {
      <div class="mt-2">
        <div class="mb-2 d-flex align-items-center justify-content-between">
          <div class="fw-bold fs-6 title">Refund Amounts</div>
          @if (form1.get('refundAmountTTL').value) {
            <div style="font-size:1rem;font-weight:600;color:#2d6a2d;">
              Total: ${{form1.get('refundAmountTTL').value | number:'1.2-2'}}
            </div>
          }
        </div>
        <div class="row">
          <div class="col-lg-12">
            @if (noRefundAmountsError) {
              <small class="p-invalid d-block mb-2">At least one refund amount is required.</small>
            }
            <app-guest-refund-reason-list [guestRefundId]="guestRefundId"
              [guestRefundLastName]="guestLastName" [showFilter]="false" [showPagination]="false" [outlineNewButton]="false"
              (totalRefundAmount)="totalRefundAmount($event)" (totalRefundAmountDeduct)="totalRefundAmountDeduct($event)">
            </app-guest-refund-reason-list>
            @if (form1.get('refundAmountTTL').value) {
              <div style="border-top:2px solid #dee2e6;margin-top:4px;padding-top:8px;text-align:right;font-weight:700;font-size:1rem;">
                Total Refund: ${{form1.get('refundAmountTTL').value | number:'1.2-2'}}
              </div>
            }
          </div>
        </div>
      </div>
    }

    <p-dialog [(visible)]="showProcessRefundDialog" header="Confirm Refund Processing"
      [modal]="true" [closable]="true" [draggable]="false" [resizable]="false"
      [style]="{'width':'440px'}" appendTo="body">
      @if (loadingCardInfo) {
        <div class="text-center py-3">
          <i class="pi pi-spin pi-spinner" style="font-size:1.5rem"></i>
        </div>
      }
      @if (!loadingCardInfo) {
        <div class="mb-3">
          <strong>Refund Amount:</strong>
          ${{ form1.get('refundAmountTTL').value | number:'1.2-2' }}
        </div>
        <div class="mb-3">
          <strong>Charge to:</strong>
          @if (refundCardInfo?.hasCards) {
            <p-dropdown class="w-100 d-block mt-2"
              [options]="refundCardInfo.cards"
              [(ngModel)]="selectedPaymentSourceId"
              [ngModelOptions]="{standalone:true}"
              optionLabel="name"
              optionValue="value"
              placeholder="Select card to charge"
              appendTo="body">
            </p-dropdown>
          }
          @if (!refundCardInfo?.hasCards) {
            <span style="color:#c0392b;"> No card on file — manual processing required</span>
          }
        </div>
        <div class="mb-3">
          <span class="p-float-label w-100">
            <input id="refundPassword" type="password" pInputText class="w-100"
              [(ngModel)]="processRefundPassword" [ngModelOptions]="{standalone:true}"/>
            <label for="refundPassword">Your Admin Password</label>
          </span>
        </div>
      }
      <ng-template pTemplate="footer">
        <button pButton class="p-button-text" (click)="showProcessRefundDialog=false"
          [disabled]="processingRefund">Cancel</button>
        <button pButton class="p-button-danger" (click)="onConfirmProcessRefund()"
          [disabled]="!processRefundPassword || processingRefund || loadingCardInfo || (refundCardInfo?.hasCards && !selectedPaymentSourceId)">
          {{ processingRefund ? 'Processing...' : 'Confirm Process Refund' }}
        </button>
      </ng-template>
    </p-dialog>

  </div>
    </p-tabPanel>

    <p-tabPanel header="History" *ngIf="guestRefundId">
      <app-audit-list [auditUrl]="'guestRefunds/' + guestRefundId + '/audit'"></app-audit-list>
    </p-tabPanel>

  </p-tabView>
</div>
<div class="row m-0" style="position:sticky;bottom:0;background:#fff;z-index:5;padding:8px 0;border-top:1px solid #dee2e6;">
  <div class="col-lg-12">
    <div class="btn-group">
      <div class="button-group">
        @if (guestRefundId) {
          <button pButton class="btn-delete p-button-outlined p-button-danger"
          [disabled]="formLoading"
          (click)="onFormDelete()">{{ formAction === 'delete' ? 'Deleting...' : 'Delete' }}</button>
        }
      </div>

      <div class="button-group">
        @if (guestRefundId && (form1.get('status').value === '0' || form1.get('status').value === '1') && form1.get('refundAmountTTL').value > 0) {
          <button pButton
            class="p-button-outlined p-button-success"
            style="font-size:0.9rem;"
            [disabled]="sendingCreditAuth"
            (click)="onSendCreditAuth()">
            <mat-icon style="font-size:18px;vertical-align:middle;margin-right:6px;">send</mat-icon>
            {{ sendingCreditAuth ? 'Sending...' : (form1.get('status').value === '1' ? 'Resend Credit Auth' : 'Send Credit Auth') }}
          </button>
          @if (creditAuthSent) {
            <span style="color:green;font-size:0.85rem;margin-left:12px;">Sent successfully.</span>
          }
        }
        @if (guestRefundId && form1.get('status').value === '2') {
          <button pButton
            class="p-button-danger"
            style="font-size:0.9rem;"
            [disabled]="processingRefund"
            (click)="onProcessRefundClick()">
            <mat-icon style="font-size:18px;vertical-align:middle;margin-right:6px;">payments</mat-icon>
            Process Refund
          </button>
        }
      </div>

      <div class="button-group">
        <button pButton class="btn-cancel p-button-text" [disabled]="formLoading" [mat-dialog-close]="true">Cancel</button>
        @if (!guestRefundId) {
          <button pButton class="btn-addt p-button" [disabled]="formLoading || addCompleted" (click)="formAdd()">
            {{ formAction === 'add' ? 'Adding...' : 'Next >>' }}
          </button>
        }

        @if (guestRefundId) {
          <button pButton  class="btn-upt p-button" [disabled]="formLoading" (click)="formUpdate()">
            {{ formAction === 'update' ? 'Updating...' : 'Update' }}
          </button>
        }
      </div>
    </div>
  </div>
</div>
